<template>
  <div>
    <!-- Overlay oscuro (solo móvil, cuando el drawer está abierto) -->
    <div
      class="sidebar-overlay"
      :class="{ 'sidebar-overlay--visible': mobileOpen }"
      @click="closeMobile"
    ></div>

    <div
      class="side-menu"
      :class="{
        'side-menu--collapsed': isCollapse,
        'side-menu--mobile-open': mobileOpen,
      }"
    >
      <!-- LOGO / MARCA -->
      <div class="side-brand">
        <div class="side-brand__badge">
          <span>720</span>
        </div>
        <span v-if="seen" class="side-brand__name">720tec</span>
      </div>

      <!-- USUARIO -->
      <div class="side-user">
        <div class="side-user__avatar">
          {{ username ? username.charAt(0).toUpperCase() : "U" }}
        </div>
        <div v-if="seen" class="side-user__info">
          <div class="side-user__name">{{ username }}</div>
          <div class="side-user__role">{{ roleLabel }}</div>
        </div>
        <button
          class="side-user__logout"
          :title="$t('main.logout')"
          @click="logOut()"
        >
          <i class="fas fa-sign-out-alt"></i>
        </button>
      </div>

      <!-- NAVEGACIÓN -->
      <nav class="side-nav">
        <button
          class="side-nav__item"
          :class="{ 'side-nav__item--active': currentPath === '/orders' }"
          onclick="window.location='/orders';"
        >
          <i class="fas fa-file-video side-nav__icon"></i>
          <span v-if="seen">{{ $t("main.menu.loads") }}</span>
        </button>

        <button
          class="side-nav__item"
          :class="{ 'side-nav__item--active': currentPath === '/supervisor' }"
          onclick="window.location='/supervisor';"
        >
          <i class="fas fa-eye side-nav__icon"></i>
          <span v-if="seen">{{ $t("main.menu.supervisor") }}</span>
        </button>

        <button
          v-if="role === 'admin' && hasAxisCameras"
          class="side-nav__item"
          :class="{ 'side-nav__item--active': currentPath === '/storage' }"
          onclick="window.location='/storage';"
        >
          <i class="fas fa-hdd side-nav__icon"></i>
          <span v-if="seen">{{ $t("main.menu.axisStatus") }}</span>
        </button>
      </nav>

      <!-- BOTÓN COLAPSAR (solo escritorio) -->
      <div class="side-collapse">
        <button class="side-collapse__btn" @click="colapsar">
          <i :class="seen ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import storage from "@/components/utils/storage";
import authService from "@/services/auth.service";
import { loadrecorders } from "@/services/supervisor.api";

export default {
  name: "SideBar",
  data() {
    return {
      username: "",
      isCollapse: false,
      seen: true,
      mobileOpen: false,
      currentPath: window.location.pathname,
      hasAxisCameras: false,
    };
  },
  computed: {
    roleLabel() {
      if (this.role === "admin") return "Administrador";
      if (this.role === "user") return "Usuario";
      return this.role || "";
    },
  },
  async created() {
    this.username = storage.loadUsername();
    this.role = storage.loadIsRole();

    if (this.role === "admin") {
      await this.checkAxisCameras();
    }
  },
  mounted() {
    this.$root.$on("toggle-sidebar", this.toggleMobile);
  },
  beforeDestroy() {
    this.$root.$off("toggle-sidebar", this.toggleMobile);
  },
  methods: {
    async checkAxisCameras() {
      try {
        const recorders = await loadrecorders();
        this.hasAxisCameras = recorders.some((r) => r.isAxis === true);
      } catch (e) {
        console.error("Error comprobando cámaras Axis:", e);
        this.hasAxisCameras = false;
      }
    },
    colapsar: function () {
      this.isCollapse = !this.isCollapse;
      this.seen = !this.seen;
    },
    iconoColapsar: function () {
      if (this.isCollapse) {
        return "el-icon-arrow-right";
      } else {
        return "el-icon-arrow-left";
      }
    },
    toggleMobile: function () {
      this.mobileOpen = !this.mobileOpen;
    },
    closeMobile: function () {
      this.mobileOpen = false;
    },
    logOut: function () {
      if (authService.isUsingOAuth2()) {
        this.logoutOAuth2();
      } else {
        this.logoutLegacy();
      }
    },
    logoutOAuth2: function () {
      storage.saveAuthenticated(false);
      storage.saveToken("", "", "");
      storage.removeItemsSessionStorage();

      const keycloakLogoutUrl =
        "http://auth.transport.bio/realms/THT/protocol/openid-connect/logout";
      const redirectUri = encodeURIComponent(
        "https://recordings.transport.bio"
      );
      const clientId = "oauth2-proxy";
      window.location.href = `${keycloakLogoutUrl}?client_id=${clientId}&post_logout_redirect_uri=${redirectUri}`;
    },
    logoutLegacy: function () {
      storage.saveAuthenticated(false);
      storage.saveToken("", "", "");
      storage.removeItemsSessionStorage();
      this.$router.replace({ name: "login" });
    },
  },
};
</script>

<style>
/* ── OVERLAY (móvil) ───────────────────────────────────────────── */
.sidebar-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 199;
  opacity: 0;
  transition: opacity 0.25s;
  pointer-events: none;
}

/* ── CONTENEDOR ────────────────────────────────────────────────── */
.side-menu {
  height: 100%;
  width: 196px;
  background-color: #1e293b;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  border-right: 1px solid rgba(255, 255, 255, 0.06);
  transition: width 0.22s ease;
  overflow: hidden;
}

.side-menu--collapsed {
  width: 52px;
}

/* ── LOGO / MARCA ──────────────────────────────────────────────── */
.side-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}

.side-brand__badge {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background-color: #0284c7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.side-brand__badge span {
  color: #fff;
  font-weight: 800;
  font-size: 10px;
}

.side-brand__name {
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  white-space: nowrap;
}

/* ── USUARIO ───────────────────────────────────────────────────── */
.side-user {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}

.side-user__avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

.side-user__name {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.side-user__role {
  color: #94a3b8;
  font-size: 10px;
  white-space: nowrap;
}

.side-user__logout {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: #ef4444;
  border: none;
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
  margin-left: auto;
  font-size: 11px;
  box-shadow: 0 2px 6px rgba(239, 68, 68, 0.4);
  transition: background-color 0.15s, transform 0.15s;
}

.side-user__logout:hover {
  background-color: #dc2626;
  transform: scale(1.08);
}

/* ── NAVEGACIÓN ────────────────────────────────────────────────── */
.side-nav {
  flex: 1;
  padding: 8px 0;
  display: flex;
  flex-direction: column;
}

.side-nav__item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 12px;
  border: none;
  border-left: 2px solid transparent;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
  font-size: 13px;
  font-weight: 400;
  text-align: left;
  transition: all 0.15s;
  white-space: nowrap;
}

.side-nav__item:hover {
  background-color: rgba(2, 132, 199, 0.1);
  color: #38bdf8;
  border-left-color: #0284c7;
}

.side-nav__item--active {
  background-color: rgba(2, 132, 199, 0.1);
  color: #0284c7 !important;
  border-left-color: #0284c7;
  font-weight: 600;
}

.side-nav__icon {
  font-size: 14px;
  flex-shrink: 0;
  width: 16px;
  text-align: center;
}

/* ── BOTÓN COLAPSAR ────────────────────────────────────────────── */
.side-collapse {
  padding: 10px 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}

.side-menu--collapsed .side-collapse {
  justify-content: center;
}

.side-collapse__btn {
  background: transparent;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: color 0.15s;
}

.side-collapse__btn:hover {
  color: #fff;
}

/* ── LEGACY ────────────────────────────────────────────────────── */
.empty {
  height: 70px;
  background-color: white;
  position: relative;
  top: -5px;
}

/* ── RESPONSIVE: tablet / móvil (≤ 768px) ─────────────────────── */
@media (max-width: 768px) {
  /* Overlay activo */
  .sidebar-overlay {
    display: block;
  }

  .sidebar-overlay--visible {
    opacity: 1;
    pointer-events: all;
  }

  /* Drawer: oculto fuera de pantalla por defecto */
  .side-menu {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 240px !important;
    z-index: 200;
    transform: translateX(-100%);
    transition: transform 0.25s ease;
    box-shadow: none;
  }

  /* Drawer abierto */
  .side-menu--mobile-open {
    transform: translateX(0);
    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.3);
  }

  /* En móvil mostrar siempre el texto aunque esté "colapsado" */
  .side-menu .side-brand__name,
  .side-menu .side-user__info,
  .side-menu .side-nav__item span {
    display: block !important;
  }

  /* Ocultar botón colapsar en móvil */
  .side-collapse {
    display: none;
  }

  /* Ítems de nav más grandes para táctil */
  .side-nav__item {
    padding: 13px 16px;
    font-size: 14px;
  }
}
</style>
